<template>
  <b-modal :id="idModal" class="modal-info" hide-footer size="sm" scrollable centered @hide="handleOfModal">
    <template v-slot:modal-header>
      <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
        <h4 class="modal-info__title font-sanpro-bold primary-color-txt">Chia sẻ qua email</h4>
        <span @click="$bvModal.hide(idModal)" class="modal-info__close"><i class="icon-close"></i></span>
      </div>
    </template>
    <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light">
      <form @submit.prevent="handleShareByEmail">
          <div class="text-left form-group">
            <label class="font-sanpro-semibold font-size-16 secondary-color-txt">Email bạn muốn chia sẻ: </label><br>
            <input 
              type="email" 
              id="email" 
              class="form-control input-email" 
              v-model="email"
              @blur="$v.email.$touch()"
            >
            <span class="error font-size-14 color-err display-block" v-if="$v.email.$dirty && !$v.email.required">Vui lòng điền email</span>
            <span class="error font-size-14 color-err display-block" v-if="!$v.email.email">Định dạng email chưa đúng</span>
          </div>
          <div class="text-center form-group form-action">
            <button class="btn btn-main border-rd-20 font-size-16 font-sanpro-semibold line-height-1" :disabled="$v.email.$invalid || loading"><i class="icon-email color-light"></i> Chia sẻ</button>
          </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
  import { ID_MODAL_SHARE_MAIL } from './../../_store/constants'
  import { required, email } from 'vuelidate/lib/validators'
  import { shareSocialByMail } from './../../_api/'
  import { mapState, mapActions } from 'vuex'
  import { STATUS_SUCCESS } from '@/store/common/constants'

  export default {
    name: 'ModalShareEmail',
    props: {
      linkShare: String
    },
    data () {
      return {
        idModal: ID_MODAL_SHARE_MAIL,
        email: ''
      }
    },
    validations:{
      email:{
        required,
        email,
      },
    },
    computed: {
      ...mapState('common', ['loading'])
    },
    methods: {
      ...mapActions('common', ['setLoading', 'acToggleModalShareMedia']),

      handleShareByEmail(e){
        let self = this
        if (self.$v.$invalid) {
          return;
        }
        let payload = {email: self.email, url: self.linkShare}
        self.setLoading(true)
        shareSocialByMail(payload).then(res => {
          if (res.status === STATUS_SUCCESS) {
            self.$toast.success('Chia sẻ thành công!')
            self.handleOfModal()
            self.acToggleModalShareMedia(false)
          }
        }).finally(() => self.setLoading(false))
      },

      handleOfModal () {
        this.$bvModal.hide(ID_MODAL_SHARE_MAIL)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal-info__body {
    form {
      label, input {
        margin-bottom: 15px;
      }
    }

    .form-action {
      button {
        letter-spacing: 0.03em;
        i {
          margin-right: 8px
        }
      }
    }
  }
</style>